'use client'
import { useState } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import CMButton from './buttons/cmButton'
import DropdownComponent from './drop-down/drop-down'
import { ViewPort } from '@/enum/enum'
import { HeaderLayout, GeneralLayout } from '@/payload-types'

interface IProps {
  viewPort: ViewPort
  onLinkClick?: () => void
  header?: HeaderLayout
  general?: GeneralLayout
}

const NavLinks = ({ viewPort, onLinkClick, header, general }: IProps) => {
  const url = usePathname()
  const [openDropdownKey, setOpenDropdownKey] = useState('')

  const toggleDropdown = (key: string) => {
    openDropdownKey === key ? setOpenDropdownKey('') : setOpenDropdownKey(key)
  }

  const handleLinkClick = () => {
    onLinkClick && onLinkClick()
  }

  return (
    <>
      <nav
        className={`relative w-[980px] max-[1200px]:w-full w-full items-stretch content-between ${
          viewPort === 'deskTop' ? 'flex max-[1200px]:hidden' : ''
        }`}
      >
        <ul
          className={`my-0 ml-[55px] mr-[45px] font-medium text relative list-none flex items-center ${
            viewPort === 'mobile' &&
            'max-[1200px]:flex max-[1200px]:flex-col max-[1200px]:items-start max-[1200px]:justify-start justify-between max-[1200px]:right-0 max-[1200px]:leading-normal max-[1200px]:text-lg  max-[1200px]:m-0 !leading-[25.7143px]'
          }`}
        >
          {general?.menu?.map((item) =>
            item.subMenu?.length != 0 ? (
              <li
                className={`text-white leading-[25.7143px] text-lg md:text-base cursor-pointer my-0 mx-[25px] md:mx-[30px] ${
                  viewPort === 'mobile' ? 'max-[1200px]:py-[10px] max-[1200px]:px-0' : ''
                }`}
                key={item.name}
              >
                <DropdownComponent
                  menuItems={item.subMenu}
                  title={`${item.name}`}
                  viewPort={viewPort}
                  onItemClick={handleLinkClick}
                  isOpen={openDropdownKey === `${item.name}`}
                  toggleDropdown={() => toggleDropdown(`${item.name}`)}
                  keyValue={item.name!.replace(/\s+/g, '_')}
                />
              </li>
            ) : (
              <li
                className={`text-white leading-[25.7143px] text-lg md:text-base cursor-pointer my-0 mx-[25px] md:mx-[30px] justify-between xl:hover:z-[1] xl:hover:border-b xl:hover:border-feYellow xl:hover:rounded-[2px] hover:bottom-b-0 active:bottom-b-0 border-b-0 ${
                  viewPort === 'mobile' ? 'max-[1200px]:py-[10px] max-[1200px]:px-0' : ''
                } ${
                  url === item.url
                    ? 'max-[1200px]:active:bottom-b-0 max-[1200px]:underline max-[1200px]:decoration-feYellow max-[1200px]:decoration-1 max-[1200px]:underline-offset-4'
                    : ''
                }`}
                key={item.name}
              >
                <Link
                  href={`${item.url}`}
                  onClick={handleLinkClick}
                  className={
                    url === item.url
                      ? 'leading-[25.7143px] text-lg md:text-base text-white max-[1200px]:hover:bottom-b-0 max-[1200px]:active:bottom-b-0 max-[1200px]:underline max-[1200px]:decoration-feYellow max-[1200px]:decoration-1 max-[1200px]:underline-offset-4'
                      : 'leading-[25.7143px] text-lg md:text-base text-white'
                  }
                >
                  {item.name}
                </Link>
              </li>
            ),
          )}
        </ul>
        {viewPort === ViewPort.DESKTOP && header?.donateButton && (
          <div className="self-center">
            <CMButton
              buttonType="donateButton"
              buttonText="DONATE"
              href="https://buy.stripe.com/28obJ72az6zz5cQ5kv"
              link={true}
              className="donate"
              target={true}
            />
          </div>
        )}
      </nav>
    </>
  )
}

export default NavLinks
